var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { "mb-2": "", row: "", wrap: "" } },
    _vm._l(_vm.coButtons, function(btn, index) {
      return _c(
        "v-flex",
        {
          key: index,
          staticClass: "pr-2",
          attrs: {
            xs6: _vm.coButtons.length === 2,
            xs4: _vm.coButtons.length === 3
          }
        },
        [
          _c(
            "v-btn",
            {
              class: _vm.disabled
                ? "secondary--grey"
                : _vm.getActivedColor(btn.value)
                ? "secondary--active"
                : "secondary--normal",
              attrs: {
                round: "",
                block: "",
                color: "secondary",
                outline: !_vm.getActivedColor(btn.value),
                disabled: _vm.disabled
              },
              on: {
                click: function($event) {
                  _vm.handleButtonClick(btn.value)
                }
              }
            },
            [
              _vm._v(
                "\n          " + _vm._s(_vm.$t(btn.translationKey)) + "\n    "
              )
            ]
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54cb0757", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54cb0757","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal-group-round-buttons/template.html
// module id = null
// module chunks = 